import { useEffect, useState } from "react";

// realtimeモード中だけ現在時刻(ms)を1秒刻みで更新するhook。
export const useRealtimeNowMs = (isRealtime: boolean) => {
  const [realtimeNowMs, setRealtimeNowMs] = useState<number>(() => Date.now());

  useEffect(() => {
    if (!isRealtime) return;
    setRealtimeNowMs(Date.now());
    const id = window.setInterval(() => setRealtimeNowMs(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [isRealtime]);

  return realtimeNowMs;
};
